import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupIcon from '@mui/icons-material/Group';

// Mock data for batches - replace with API call
const mockBatches = [
  { id: 1, name: 'Batch A 2024', startDate: '2024-01-15', studentCount: 30, status: 'Active' },
  { id: 2, name: 'Weekend Warriors', startDate: '2024-02-01', studentCount: 25, status: 'Active' },
  { id: 3, name: 'Summer Prep Batch', startDate: '2023-06-01', studentCount: 40, status: 'Completed' },
];

const BatchManagement = () => {
  // State for managing batches (will be fetched from API later)
  const [batches, setBatches] = React.useState(mockBatches);
  // State for dialogs (e.g., create/edit batch)
  const [openCreateDialog, setOpenCreateDialog] = React.useState(false);

  const handleCreateBatch = () => {
    // Logic to open a dialog or navigate to a create batch page
    console.log('Create new batch');
    setOpenCreateDialog(true); // Placeholder for opening a dialog
  };

  const handleEditBatch = (batchId) => {
    // Logic to open a dialog or navigate to an edit batch page
    console.log('Edit batch:', batchId);
  };

  const handleDeleteBatch = (batchId) => {
    // Logic to delete a batch (with confirmation)
    console.log('Delete batch:', batchId);
    // Example: setBatches(batches.filter(batch => batch.id !== batchId));
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <GroupIcon sx={{ mr: 1 }} /> Batch Management
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleCreateBatch}
        >
          Create New Batch
        </Button>
      </Box>

      <Paper elevation={3} sx={{ p: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Batch Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="right">Start Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="right">Students</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {batches.map((batch) => (
                <TableRow
                  key={batch.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {batch.name}
                  </TableCell>
                  <TableCell align="right">{batch.startDate}</TableCell>
                  <TableCell align="right">{batch.studentCount}</TableCell>
                  <TableCell align="center">
                    <Typography 
                      variant="caption" 
                      sx={{
                        bgcolor: batch.status === 'Active' ? 'success.light' : 'warning.light',
                        color: batch.status === 'Active' ? 'success.contrastText' : 'warning.contrastText',
                        p: '2px 8px',
                        borderRadius: '4px'
                      }}
                    >
                      {batch.status}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Edit Batch">
                      <IconButton color="primary" onClick={() => handleEditBatch(batch.id)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Batch">
                      <IconButton color="error" onClick={() => handleDeleteBatch(batch.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Placeholder for Create/Edit Batch Dialog */}
      {/* <Dialog open={openCreateDialog} onClose={() => setOpenCreateDialog(false)}>
        <DialogTitle>Create New Batch</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" label="Batch Name" type="text" fullWidth />
          <TextField margin="dense" label="Start Date" type="date" fullWidth InputLabelProps={{ shrink: true }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCreateDialog(false)}>Cancel</Button>
          <Button onClick={() => setOpenCreateDialog(false)}>Create</Button> // Add actual create logic
        </DialogActions>
      </Dialog> */}
    </Container>
  );
};

export default BatchManagement;